<template>
  <div id="detail">
    <comp-header
      :headerPosition="headerPos"
      :leftLink="headerLeftLink"
      :rightLink="headerRightLink"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
      :rightClick="editProfile"
    />
    <div class="detail-wrapper">
      <div class="detail-container">
        <div class="profile-container">
          <comp-profile
            :userInitial="userName"
            :editBtn="btnEdit"
            @changeImage="changeImage"
            :profileImage="getProfileImage"
          />
        </div>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.name") }}</td>
            <td>
              <form-input
                :inputType="typeText"
                :placeholderText="nameHolder"
                :inputStyle="
                  isNameValidation ? styleUnderColor : styleUnderAlert
                "
                :inputValue="name"
                v-on:inputParent="
                  value => {
                    name = value;
                  }
                "
              />
            </td>
          </tr>
        </table>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.nickname") }}</td>
            <td>
              <form-input
                :inputType="typeText"
                :placeholderText="nickHolder"
                :inputStyle="
                  isNicknameValidation ? styleUnderColor : styleUnderAlert
                "
                :inputValue="nickname"
                v-on:inputParent="
                  value => {
                    nickname = value;
                  }
                "
              />
            </td>
          </tr>
        </table>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.email") }}</td>
            <td>
              <form-input
                :inputType="typeEmail"
                :placeholderText="emailHolder"
                :inputStyle="
                  isEmailValidation ? styleUnderColor : styleUnderAlert
                "
                :inputValue="email"
                v-on:inputParent="
                  value => {
                    email = value;
                  }
                "
              />
            </td>
          </tr>
        </table>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.birth") }}</td>
            <td>
              <form-select
                :inputStyle="styleUnderColor"
                :optionDatas="yearData"
                @selectParent="checkBirth"
                :selected="yearSelected"
              />
            </td>
          </tr>
        </table>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.education") }}</td>
            <td>
              <form-select
                :inputStyle="styleUnderColor"
                :optionDatas="educationData"
                @selectParent="checkEducation"
                :selected="educationSelected"
              />
            </td>
          </tr>
        </table>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t("acc.detail.jobs") }}</td>
            <td style="padding: 0 15px">
              <router-link to="/acc/job-group" class="btn-like-select">
                {{ occupation }}
              </router-link>
            </td>
          </tr>
        </table>

        <div class="btn-delete">
          <router-link to="/acc/delete">{{
            $t("acc.detail.delete")
          }}</router-link>
        </div>

        <comp-modal v-if="showModal" @confirm="profileUpdateComplete">
          <div slot="body">{{ msgModal }}</div>
        </comp-modal>
      </div>
    </div>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompProfile from '@/components/CompProfile';
import FormInput from '@/components/FormInput';
import FormSelect from '@/components/FormSelect';
import RESPONSE from '@/constants/response';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import _ from 'lodash';

export default {
  name: 'detail',
  mixins: [common],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftLink: this.$i18n.t('acc.detail.headerLeft'),
      headerRightLink: this.$i18n.t('acc.detail.headerRight'),
      headerPageTitle: this.$i18n.t('acc.detail.header'),

      userName: '',
      btnEdit: 'on',
      image: '',

      typeText: 'text',
      typeEmail: 'email',

      nameHolder: this.$i18n.t('acc.detail.name'),
      nickHolder: this.$i18n.t('acc.detail.nickname'),
      emailHolder: this.$i18n.t('acc.detail.email'),

      styleUnderColor: 'underline-color',
      styleUnderAlert: 'underline-color-alert',

      name: this.$store.getters.getTmpUserName,
      inputName: this.$store.getters.getTmpUserName,
      nickname: this.$store.getters.getTmpUserNickname,
      email: this.$store.getters.getTmpUserEmail,
      birthYear: this.$store.getters.getTmpUserBirth,
      education: this.$store.getters.getTmpUserEducation,
      jobs: '',
      occupation: this.$i18n.t('acc.detail.jobs'),

      yearSelected: this.$store.getters.getTmpUserBirth
        ? this.$store.getters.getTmpUserBirth
        : '0',
      sexSelected: this.$store.getters.getTmpUserSex
        ? this.$store.getters.getTmpUserSex
        : '0',
      educationSelected: this.$store.getters.getTmpUserEducation
        ? this.$store.getters.getTmpUserEducation
        : '0',

      yearData: this.years(),
      educationData: this.educations(),

      validEmailFlag: this.$store.getters.getTmpValidEmailFlag,
      validNicknameFlag: this.$store.getters.getTmpValidNicknameFlag,
      validNameFlag: this.$store.getters.getTmpValidNameFlag,

      imageFile: '',

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,

      showModal: false,
      msgModal: '',

      isLoading: false,
      editDone: false,
    };
  },
  components: {
    CompHeader,
    CompProfile,
    FormInput,
    FormSelect,
    CompModal,
    CompLoading,
  },
  computed: {
    isNameValidation() {
      return this.validNameFlag;
    },
    isNicknameValidation() {
      return this.validNicknameFlag;
    },
    isEmailValidation() {
      return this.validEmailFlag;
    },
    getProfileImage() {
      return this.$store.getters.getProfileImage;
    },
  },
  watch: {
    name() {
      this.checkName();
    },
    nickname() {
      this.checkNickname();
    },
    email() {
      this.checkEmail();
    },
  },
  methods: {
    checkName: _.debounce(function checkName() {
      this.$store.dispatch('setTmpUserName', this.name).then(() => {
        this.validNameFlag = this.validName(this.name);
        return this.$store
          .dispatch('setTmpValidNameFlag', this.validNameFlag)
          .then(() => this.validNameFlag);
      });
    }, 1000),

    checkNickname: _.debounce(function checkNickname() {
      this.$store.dispatch('setTmpUserNickname', this.nickname).then(() => {
        this.validNicknameFlag = this.validNickname(this.nickname);
        return this.$store
          .dispatch('setTmpValidNicknameFlag', this.validNicknameFlag)
          .then(() => this.validNicknameFlag);
      });
    }, 1000),

    checkEmail: _.debounce(function checkEmail() {
      this.$store.dispatch('setTmpUserEmail', this.email).then(() => {
        this.validEmailFlag = this.validEmail(this.email);
        return this.$store
          .dispatch('setTmpValidEmailFlag', this.validEmailFlag)
          .then(() => this.validEmailFlag);
      });
    }, 1000),

    checkBirth(value) {
      this.$store.dispatch('setTmpUserBirth', value).then(() => {
        this.birthYear = value;
        return this.birthYear;
      });
    },

    checkEducation(value) {
      this.$store.dispatch('setTmpUserEducation', value).then(() => {
        this.education = value;
        return this.education;
      });
    },

    editProfile() {
      this.isLoading = true;

      const errors = [];
      if (!this.validEmail(this.email)) {
        this.validEmailFlag = false;
        errors.push(this.$i18n.t('error.invalid.email'));
      }
      if (!this.validEmailFlag) {
        errors.push(this.$i18n.t('error.invalid.duplicateEmail'));
      }
      if (!this.validNickname(this.nickname)) {
        errors.push(this.$i18n.t('error.invalid.nickname'));
      }
      if (!this.validName(this.name)) {
        errors.push(this.$i18n.t('error.invalid.name'));
      }
      if (errors.length > 0) {
        this.msgModal = errors[0];
        this.showModal = true;

        this.editDone = false;
        this.isLoading = false;
      } else {
        if (!this.imageFile) {
          this.imageFile = null;
        }
        if (this.$store.getters.getTagCodeList) {
          this.jobs = this.$store.getters.getTagCodeList;
        }
        const data = {
          name: this.removeEmojiText(this.name),
          nickname: this.removeEmojiText(this.nickname),
          email: this.email,
          birth: this.birthYear,
          education: this.education,
          image: this.imageFile,
          jobs: this.jobs,
        };

        this.$store.dispatch('editProfile', { data }).then((response) => {
          this.isLoading = false;
          this.editDone = true;

          if (response.status === RESPONSE.SUCCESS.CODE) {
            this.msgModal = this.$i18n.t('acc.detail.completed');
            this.showModal = true;

            const userSeqId = this.$store.getters.getUserSeqId;
            this.$store.dispatch('getProfile', { userSeqId }).then((result) => {
              localStorage.profileImage = `${process.env.API_BASE_URL}/files/${userSeqId}/${result.data.photo.fileName}`;
              this.$store.commit('setUserName', result.data.name);
              this.$store
                .dispatch('setProfileImage', localStorage.profileImage)
                .then();
            });
          }
        });
      }
    },
    changeImage(file) {
      this.userName = null;
      this.imageFile = file;
    },
    getProfile() {
      this.isLoading = true;

      const userSeqId = this.$store.getters.getUserSeqId;
      this.$store.dispatch('getProfile', { userSeqId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getProfile();
            } else {
              this.invalidateLogin();
            }
          });
        } else {
          const profile = data.data;
          this.name = this.name ? this.name : profile.name;
          if (profile.name) {
            this.userName = profile.name.split('')[0];
          }
          this.nickname = this.nickname ? this.nickname : profile.nickname;
          this.birthYear = this.birthYear ? this.birthYear : profile.birth;
          this.yearSelected = this.birthYear ? this.birthYear : profile.birth;
          if (profile.etc) {
            this.email = this.email ? this.email : profile.etc.email;
            this.education = this.education
              ? this.education
              : profile.etc.education;
            this.educationSelected = this.education
              ? this.education
              : profile.etc.education;
            if (profile.etc.jobs) {
              this.jobs = JSON.parse(profile.etc.jobs);
              const storeJobList = this.$store.getters.getJobs;
              const tmpList = [];
              for (let i = 0; i < storeJobList.length; i += 1) {
                for (let j = 0; j < this.jobs.length; j += 1) {
                  if (storeJobList[i].jobCode === this.jobs[j]) {
                    this.$store.dispatch('addTmpTag', storeJobList[i]);
                    tmpList.push(storeJobList[i].jobName);
                  }
                }
              }
              if (this.$store.getters.getTagCodeList.length === 0) {
                this.$store.dispatch('copyTmpTagList').then();
              }
            }
          }
          if (this.$store.getters.getTagList) {
            const tagList = this.$store.getters.getTagList;
            if (tagList.length > 0) {
              const tmpList = [];
              for (let ii = 0; ii < tagList.length; ii += 1) {
                tmpList.push(tagList[ii].jobName);
              }
              this.occupation = tmpList.join(', ');
            }
          }

          this.isLoading = false;
        }
      });
    },
    profileUpdateComplete() {
      if (this.editDone) {
        this.goPage('/mc6');
      } else {
        this.showModal = false;
      }
    },
  },
  mounted() {
    this.isShowMenu(false);
  },
  created() {
    this.getProfile();
  },
};
</script>

<style lang="scss" src="../../scss/acc-detail.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-detail.vue